import { render, staticRenderFns } from "./singleFileDownload.vue?vue&type=template&id=3a6742e4"
import script from "./singleFileDownload.vue?vue&type=script&lang=js"
export * from "./singleFileDownload.vue?vue&type=script&lang=js"
import style0 from "./singleFileDownload.vue?vue&type=style&index=0&id=3a6742e4&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports